<template>
  <div class="newBreadcrumb">
    <v-breadcrumbs :items="breadcrumbList" divider="/"></v-breadcrumbs>
  </div>
</template>
<script>
export default {
  name: "Breadcrumb",
  data() {
    return {
      breadcrumbList: []
    };
  },
  mounted() {
    this.updateList();
  },
  watch: {
    $route() {
      this.updateList();
    }
  },
  methods: {
    updateList() {
      this.breadcrumbList = this.$route.meta.breadcrumb;
    }
  }
};
</script>
<style>
.newBreadcrumb {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 1rem;
  list-style: none;
  background-color: #e9ecef;
  border-radius: 0.25rem;
}
</style>